import Box from '@material-ui/core/Box';
import React from 'react';
import Linkify from 'react-linkify';
import { useStyles } from '../TrackPage';

interface TrackDescriptionProps {
  description?: string;
  descriptionHtml?: string;
  featuredImage?: string;
  trackName: string;
}

export const TrackDescription: React.FC<TrackDescriptionProps> = ({
  description,
  descriptionHtml,
  featuredImage,
  trackName,
}) => {
  const styles = useStyles();

  if (!descriptionHtml && !description) {
    return null;
  }

  return (
    <>
      {!!descriptionHtml ? (
        <Box
          className={`${styles.descriptionContainer} markdownContainer`}
        >
          {featuredImage && (
            <div style={{ textAlign: 'center' }}>
              <img
                src={featuredImage}
                alt={`${trackName} featured image`}
                className={styles.featuredImage}
              />
            </div>
          )}
          <div dangerouslySetInnerHTML={{ __html: descriptionHtml }} />
        </Box>
      ) : !!description ? (
        <Box className={styles.descriptionContainer}>
          {featuredImage && (
            <div style={{ textAlign: 'center' }}>
              <img
                src={featuredImage}
                alt={`${trackName} featured image`}
                className={styles.featuredImage}
              />
            </div>
          )}
          <h4>Description</h4>
          <Box className={styles.instructions}>
            <Linkify>{description}</Linkify>
          </Box>
        </Box>
      ) : null}
    </>
  );
};
